import React from 'react';

const MarketPanelOngoingIPO = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Ongoing IPO</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="ongoing-ipo">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Issue Size (₹ Cr)</th>
                <th>Lot Size</th>
                <th>IPO Period</th>
                <th>Offer Price (₹)</th>
                <th>Price Band (₹)</th>
                <th>Min Investment (₹)</th>
                <th>Market Cap (₹ Cr)</th>
                <th>Industry</th>
                <th>Lead Manager</th>
                <th>Subscription Status</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.company_name || '-'}</td>
                    <td>{item.issue_size || '-'}</td>
                    <td>{item.lot_size || '-'}</td>
                    <td>{item.ipo_period || '-'}</td>
                    <td>{item.offer_price || '-'}</td>
                    <td>{item.price_band || '-'}</td>
                    <td>{item.min_investment || '-'}</td>
                    <td>{item.market_cap || '-'}</td>
                    <td>{item.industry || '-'}</td>
                    <td>{item.lead_manager || '-'}</td>
                    <td>{item.subscription_status || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelOngoingIPO; 